///<reference path="../../../../typings/angularjs/angular.d.ts"/>

module TaskList {
    export interface ImportScope extends ng.IScope {
        resultHandler: ImportResultHandlerFunc;
    }
    export class ImportDirective implements ng.IDirective {

        public restrict: string = "E";
        public templateUrl: string = "importButtonTemplate.htm";
        public controllerAs: string = "importCtrl";
        public controller: string = "importController";
        public scope: { resultHandler: string } = {
            resultHandler: "=resultHandler"
        };

        public link: ng.IDirectiveLinkFn;

        constructor() {
            ImportDirective.prototype.link = (scope: ImportScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: ImportController) => {
                element.find(".buttonTitle").html(attrs["buttonText"]);
                element.on("click", (event: any) => {
                    if (event.target.id != "importFileInput") {
                        element.find("input[type=file]").click();
                    }
                });
                element.find("input[type=file]").on("change", (data) => {
                    controller.uploadFile(data.target, attrs["uploadUrl"]);
                });

                controller.resultHandler = scope.resultHandler;
            }
        }

        public static Factory() {
            var directive = () => {
                return new ImportDirective();
            }

            directive["$inject"] = [];
            return directive;
        }
    }
    app.directive("importButton", ImportDirective.Factory());
}